import React from 'react';
import { Shield, Phone as PhoneIcon, Users, Camera, AlertTriangle, FileText } from 'lucide-react';

const SCHRITTE = [
  {
    nummer: '1',
    icon: Shield,
    title: 'Unfallstelle sichern',
    text: 'Warndreieck aufstellen, Warnweste anlegen, Unfallstelle absichern. Sicherheit hat Vorrang.'
  },
  {
    nummer: '2',
    icon: PhoneIcon,
    title: 'Polizei verständigen (wenn nötig)',
    text: 'Bei Personenschäden, unklarer Schuldfrage oder größeren Sachschäden die Polizei rufen.'
  },
  {
    nummer: '3',
    icon: Users,
    title: 'Daten austauschen',
    text: 'Namen, Anschriften, Versicherungsdaten und Kennzeichen der Beteiligten notieren.'
  },
  {
    nummer: '4',
    icon: Camera,
    title: 'Schaden dokumentieren',
    text: 'Fotos von Unfallstelle, Fahrzeugpositionen und Schäden machen. Je mehr, desto besser.'
  },
  {
    nummer: '5',
    icon: AlertTriangle,
    title: 'Fahrzeug nicht voreilig reparieren',
    text: 'Vor Reparaturbeginn sollte der Schaden begutachtet werden. Sonst können Ansprüche verloren gehen.'
  },
  {
    nummer: '6',
    icon: FileText,
    title: 'Unabhängige Beratung einholen',
    text: 'Bei unklaren Situationen oder größeren Schäden kann eine Beratung helfen, Fehler zu vermeiden.'
  }
];

export const SchrittFuerSchritt = () => {
  return (
    <section className="py-28 lg:py-36 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-6xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-brand-green/8 text-brand-green-dark rounded-full text-sm font-semibold mb-6 border border-brand-green/15">
            Checkliste
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6 tracking-tight">
            Schritt für Schritt: Was Sie nach einem Unfall tun sollten
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          {SCHRITTE.map((schritt, index) => {
            const Icon = schritt.icon;
            return (
              <div key={index} className="bg-white border border-gray-100 rounded-3xl p-8 hover:border-brand-green/30 hover:shadow-xl transition-all duration-300">
                <div className="flex items-start gap-4 mb-4">
                  <div className="w-12 h-12 bg-brand-green text-white rounded-xl flex items-center justify-center font-bold text-lg flex-shrink-0">
                    {schritt.nummer}
                  </div>
                  <div className="w-12 h-12 bg-brand-green/10 rounded-xl flex items-center justify-center border border-brand-green/15 flex-shrink-0">
                    <Icon className="w-6 h-6 text-brand-green" />
                  </div>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3 tracking-tight">{schritt.title}</h3>
                <p className="text-gray-600 leading-relaxed text-[15px]">{schritt.text}</p>
              </div>
            );
          })}
        </div>

        {/* AI-Kurzantwort nach Liste */}
        <div className="bg-brand-green/5 border-l-4 border-brand-green rounded-r-xl p-6 max-w-3xl mx-auto">
          <p className="text-sm font-semibold text-brand-green-dark mb-2">In Kürze:</p>
          <p className="text-gray-700 leading-relaxed text-[15px]">
            Wer nach einem Unfall ruhig und strukturiert vorgeht, kann spätere Nachteile vermeiden.
          </p>
        </div>
      </div>
    </section>
  );
};